<template>
  <main class="plan-tratament">
    <pacient-header />

    <div class="main-content">
      <h1 class="relative">
        {{ data.title }}
      </h1>
      <p>
        {{ data.description }}
      </p>

      <div class="stages">
        <h2>
          Etape
        </h2>

        <ul>
          <li class="stage-wrapper"
              v-for="(stage, index) in data.stages"
              :key="stage.id">
            <h3 class="flex flex-between">
              <span>
                {{ index + 1 }}. {{ stage.title }}
              </span>
              <span>
                {{ stageAmount(stage) }}
              </span>
            </h3>

            <ul class="treatments">
              <li v-for="({ id, name, medic, teeth, notes, price, quantity }, idx) in stage.treatments"
                  :key="id">
                <div class="title relative">
                  <img class="absolute"
                       src="../assets/icons2/tooth-zoom.png"
                       alt="" />
                  <h4 class="flex flex-between">
                    <span>
                      {{ index + 1 }}.{{ idx + 1 }} {{ name }}
                    </span>

                    <span>
                      {{ price * quantity }}
                    </span>
                  </h4>
                </div>

                <p class="medic">
                  dr. {{ medic }}
                </p>

                <div v-if="teeth.length > 0"
                     class="mtop8px flex">
                  <i v-html="svg.tooth" />
                  <div>
                    <span class="tooth mleft10px"
                          v-for="(item, index) in teeth"
                          :key="index">
                    {{ item.index.replace(/[^0-9.]/g, '') }}
                  </span>
                  </div>
                </div>

                <p v-if="notes"
                   class="notes mtop8px">
                  {{ notes }}
                </p>
              </li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="patient-care">
        <h2>
          Patient care
        </h2>

        <ul>
          <li class="stage-wrapper"
              v-for="(item, index) in data.patientCare"
              :key="index">
            <h4>
              {{ moment(item.date).format("DD MMM YYYY") }}
            </h4>

            <div v-if="item.notes"
                 class="flex mtop15px">
              <i v-html="svg.notes" />
              <p class="mleft10px">
                {{ item.notes }}
              </p>
            </div>

            <div v-if="item.feedback"
                 class="flex mtop15px">
              <i v-html="svg.user" />
              <p class="mleft10px">
                {{ item.feedback }}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div class="conditii-comerciale">
        <h2>
          Condiții comerciale
        </h2>

        <div class="conditii-comerciale stage-wrapper">
          <p v-if="data.conditiiComerciale">
            <b>
              {{ data.conditiiComerciale.value }}
            </b>
          </p>

          <details class="pointer mtop15px">
            <summary>Detalii conditii comerciale</summary>
            <p v-if="data.conditiiComerciale"
               class="mtop8px">
              {{ data.conditiiComerciale.content }}
            </p>
          </details>

          <ul v-if="data.conditiiComerciale"
              class="mtop15px">
            <li class="mbott10px"
                v-for="(item, index) in data.conditiiComerciale.options"
                :key="index">
              <span v-if="item.date">
                {{ moment(item.date).format('DD MMM YYYY') }} > {{ item.percentage }} %
              </span>
            </li>
          </ul>

        </div>
      </div>

      <div class="preview-footer flex flex-between">
        <span>
          încasat: 0
        </span>
        <span>
          realizat: 0
        </span>
        <span>
          total: {{ total }}
        </span>
      </div>

      <div class="actions flex mtop25px">
        <button class="cancel-btn"
                @click="handleBackToPTlist">
          Înapoi
        </button>

        <button class="save-btn"
                cy="edit-btn"
                @click="handleEdit">
          Editează
        </button>
      </div>
    </div>
  </main>
</template>

<script>
  import {svg} from '@/store/svg';
  import EditIcon from '@/components/EditIcon.vue';
  import moment from 'moment';

  export default {
    name: 'PlanTratament',
    components: { EditIcon },
    data () {
      return {
        moment
      }
    },
    created () {
      const idPlanTratament = this.$route.params.idPlanTratament;
      this.$store.dispatch('get_plan_tratament', { idPlanTratament });
    },
    computed: {
      stageAmount () {
        return stage =>
          stage?.treatments?.reduce((sum, t) =>
            sum + (Number(t.price) || 0) * (Number(t.quantity) || 1), 0) || 0;
      },
      total () {
        return this.data.stages?.reduce((acc, { treatments }) => {
          acc += treatments.reduce((a, c) => +a + +c.price * c.quantity, 0);
          return acc;
        }, 0)
      },
      svg () {
        return svg
      },
      data () {
        return this.$store.state.pt.plan
      }
    },
    methods: {
      handleBackToPTlist () {
        const idPacient = this.$route.params.id;
        this.$router.push(`/pacienti/planuri-tratament/${idPacient}`);
      },
      handleEdit () {
        const idPlanTratament = this.$route.params.idPlanTratament;
        const idPacient = this.$route.params.id;
        this.$router.push(`/pacienti/plan-tratament/edit/${idPlanTratament}/${idPacient}`);
      }
    }
  }
</script>

<style lang="less">
@import "../assets/styles/var";
@import "../assets/styles/mixin";

  .plan-tratament {
    @media only screen and (min-width: 0) {
      .main-content {
        max-width: 600px;
        margin: 24px auto;
        padding-bottom: 200px;
        h1 {
          margin-bottom: 8px;
          font-size: 2rem;
          .edit-icon {
            position: absolute;
            left: -40px;
            top: -2px;
            opacity: 0.6;
          }
        }
        p {
          font-size: 1.6rem;
        }
        h2 {
          margin: 16px 0;
          font-size: 1.8rem;
          color: var(--orange);
        }
        h3 {
          font-size: 1.6rem;
        }
        h4 {
          font-size: 1.4rem;
        }
        .stage-wrapper {
          padding: 24px;
          margin-bottom: 24px;
          background-color: white;
          border: 1px solid #DCB950;
          .treatments {
            margin-left: 24px;
            margin-top: 12px;
            li {
              margin-bottom: 16px;
              .title {
                img {
                  left: -24px;
                  top: -3px;
                  width: 20px;
                }
                h4 {
                  opacity: 0.7;
                }
              }
              .medic {
                margin-top: 8px;
                color: @second-purple;
                font-size: 1.5rem;
              }
              .tooth {
                font-size: 1.4rem;
              }
              .notes {
                padding: 8px;
                border-radius: 4px;
                border: 1px solid lightgrey;
                font-size: 1.4rem;
              }
            }
          }
        }
        .conditii-comerciale {
          details,
          li {
            font-size: 1.6rem;
          }
        }
        .preview-footer {
          padding: 12px;
          background-color: var(--dark-purple);
          span {
            color: white;
            font-size: 1.4rem;
          }
        }
      }
    }
  }
</style>
